import styled from "styled-components"
import { colors } from "../../../lib/colors"

export const ToggleMenuMobileContainer = styled.div<{ showSettings: boolean }>`
  position: absolute;
  top: 32px;
  left: 0;
  width: 100%;
  height: ${({ showSettings }) =>
    showSettings ? "calc(100vh - 32px);" : "0px"};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  display: block;
  background-color: rgba(11, 10, 13, 0.8);
  @media only screen and (min-width: 768px) {
    display: none;
  }
`

export const ToggleMenuWrapper = styled.div<{ showSettings: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 240px;
  background-color: rgba(11, 10, 13, 0.9);
  top: 66px;
  border-radius: 8px;
  height: ${({ showSettings }) => (showSettings ? "214px" : "0px")};
  position: absolute;
  transition: height ${({ showSettings }) => (showSettings ? "0" : "0.167")}
    ease;
  z-index: 100;
  display: none;
  @media only screen and (min-width: 768px) {
    display: block;
    right: 18px;
  }
  /* @media only screen and (min-width: 1024px) {
    right: 40px;
  } */
`
export const ToggleMenuContent = styled.div<{ showSettings: boolean }>`
  padding: 50px 20px 20px;
  opacity: ${({ showSettings }) => (showSettings ? 1 : 0)};
  transition: opacity ${({ showSettings }) => (showSettings ? ".2s" : "0s")};
  transition-delay: ${({ showSettings }) => (showSettings ? ".2s" : "0s")};
  pointer-events: ${({ showSettings }) => (showSettings ? "auto" : "none")};
  @media only screen and (min-width: 768px) {
    padding: 0px;
  }
`

export const SubpageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    padding: 10px 10px 4px 10px;
  }
`

export const Subpage = styled.div<{ showSettings: boolean }>`
  padding: 0 0 20px;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  text-transform: capitalize;
  @media only screen and (min-width: 768px) {
    background-color: rgba(28, 30, 36, 0.6);
    border-radius: 8px;
    font-size: 20px;
    padding: 10px;
    margin-bottom: 4px;
  }
`
export const AudioWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    background: rgba(28, 30, 36, 0.5);
    border-radius: 0px 0px 6px 6px;
    padding: 10px;
  }
`
